/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Triggers_WelcomeInputs */



/**
* | output |
* | --- |
* | "Your agent is ready. Add a time or an event so it runs on its own, or run it now from its page." |
*
* @param {Agent_Triggers_WelcomeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_triggers_welcome = /** @type {((inputs?: Agent_Triggers_WelcomeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Triggers_WelcomeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ihr Agent ist bereit. Fügen Sie einen Auslöser hinzu, damit er von selbst läuft, oder starten Sie ihn jetzt auf seiner Seite.")
	return /** @type {LocalizedString} */ ("Your agent is ready. Add a time or an event so it runs on its own, or run it now from its page.")
});